import { render, staticRenderFns } from "./partnerOrdering.vue?vue&type=template&id=557969f8&scoped=true&"
import script from "./partnerOrdering.vue?vue&type=script&lang=js&"
export * from "./partnerOrdering.vue?vue&type=script&lang=js&"
import style0 from "./partnerOrdering.vue?vue&type=style&index=0&id=557969f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557969f8",
  null
  
)

export default component.exports